import React from 'react';
import PropTypes from 'prop-types';
import ExpertCaraousal1 from '../../assets/images/caraousal1.png';
import ExpertCaraousal2 from '../../assets/images/caraousal2.png';
import ExpertCaraousal3 from '../../assets/images/caraousal3.png';
import ParentCaraousal1 from '../../assets/images/caraousal4.png';
import ParentCaraousal2 from '../../assets/images/caraousal5.png';
import ParentCaraousal3 from '../../assets/images/caraousal6.png';
import { ACCOUNT_TYPES } from '../../constants';

function Carousel({ count, accountType = ACCOUNT_TYPES.EXPERT }) {
  const images = accountType === ACCOUNT_TYPES.EXPERT ? [
    { source: ExpertCaraousal2, name: 'Caraousal2' },
    { source: ExpertCaraousal3, name: 'Caraousal3' },
    { source: ExpertCaraousal1, name: 'Caraousal1' },
  ] : [
    { source: ParentCaraousal1, name: 'Caraousal1' },
    { source: ParentCaraousal2, name: 'Caraousal2' },
    { source: ParentCaraousal3, name: 'Caraousal3' },
  ];

  return (
    <img src={images[count].source} alt={images[count].name} height="auto" style={{ maxWidth: '100%' }} />
  );
}

Carousel.propTypes = {
  count: PropTypes.number,
  accountType: PropTypes.string,
};

export default Carousel;
